/* Establishing the strings associated with our breakpoints.
   IMPORTANT NOTE: These are established in our styles! Any
   changes there must be reflected here */
   
export const BREAKPOINTS = {
    SCREEN: 'BP_SCREEN',
    SMALL: 'BP_SMALL',
    MEDIUM: 'BP_MEDIUM',
    LARGE: 'BP_LARGE',
    XLARGE: 'BP_XLARGE'
}